import { TDeviceType } from '@cian/ui-kit';

export type TFormStatus = {
  status: EStatus;
};

export type TFetchFormParams = {
  name: string;
  phone: string;
  franchise: string;
};

export enum EStatus {
  Initial = 'init',
  Loading = 'loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export type TFormParams = {
  nameRef: React.RefObject<HTMLInputElement>;
  phoneRef: React.RefObject<HTMLInputElement>;
  franchiseRef: React.RefObject<HTMLInputElement>;
  disabledButton: boolean;
  device: TDeviceType;
  status: EStatus;
  onSendForm: VoidFunction;
  onFilledInput: VoidFunction;
  onBackToForm: VoidFunction;
};
